import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articles } from '@/mocks/articles';

export default function ArticlesPage() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <main className="pt-20">
        <section className="w-full px-4 md:px-6 py-12 bg-background-50">
          <div className="max-w-[900px] mx-auto">
            <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-8">
              <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-600">精选文章</span>
            </nav>

            <div className="mb-12">
              <h1 className="text-3xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
                精选文章
              </h1>
              <p className="text-foreground-500 text-sm">
                免费资源使用指南、技巧教程与深度盘点，助你更好地利用免费资源
              </p>
            </div>

            <div className="flex flex-col gap-6">
              {articles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-50 border border-background-200/70 rounded-xl p-6 hover:border-primary-200 transition-all duration-200"
                >
                  <div className="flex flex-col sm:flex-row sm:items-start gap-4">
                    <div className="w-full sm:w-48 h-32 rounded-lg overflow-hidden flex-shrink-0 bg-background-100">
                      <img
                        src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20digital%20art%20with%20soft%20warm%20gradients%20cream%20and%20amber%20tones%2C%20clean%20modern%20design%20with%20subtle%20geometric%20elements%2C%20bright%20airy%20atmosphere%2C%20editorial%20style&width=400&height=300&seq=article-card-generic&orientation=landscape"
                        alt={article.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="px-2 py-0.5 bg-accent-50 text-accent-700 text-[11px] rounded-md font-medium">
                          {article.category}
                        </span>
                        <span className="text-foreground-400 text-[11px]">{article.publishDate}</span>
                      </div>
                      <h2 className="text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors font-heading mb-2">
                        {article.title}
                      </h2>
                      <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2 mb-3">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center gap-4 text-foreground-400 text-xs">
                        <span className="flex items-center gap-1">
                          <i className="ri-time-line"></i>
                          {article.readTime}
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-user-line"></i>
                          {article.author}
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}